import useSWR from 'swr';
import { api } from '../components/utils/Api'

export function useSWRQuery (key) {

  return useSWR( key, api.getCards  );
}